<template>
  <div class="r-main">
    <div class="r-nums">
      共找到 <span>{{ num }}</span> 条信息
    </div>
    <slot :data="dataList" name="main" v-if="dataList.length != 0" ></slot>
    <div v-else>
      <el-empty description="无内容"></el-empty>
    </div>
    <Pagination :limit="limit" :total="count" @handleCurrentChange="handerChange" ref="pagin"></Pagination>
  </div>
</template>

<script>
  import {mainSearch} from '../../api/resource'
  import Pagination from "../../components/common/Pagination";
  import { Loading } from 'element-ui';
  export default {
    name: 'PortalInBooks',
    components: {Pagination},
    data() {
      return {
        // 存放 检索条件 普通、高级
        pageEsParams: [],
        // 存放字库检索条件
        sublibrary: [],
        num: '',
        dataList: [],
        currPage: 1,
        limit: 10,
        count: 0,
        loading:null
      };
    },
    mounted() {
      this.$Bus.$on('esParams', (data) => {
        this.pageEsParams = data.map(data => {
          delete data.guid
          return data
        })
        this.pagin()
        this.currPage = 1
        this.openLoading()
        this.getData()
      })
      this.$Bus.$on('sublibrary', (data) => {
        this.sublibrary = data
        this.currPage = 1
        this.pagin()
        this.openLoading()
        this.getData()
      })
      this.$Bus.$on('classification', (data) => {
        this.openLoading()
        this.getData()
        console.log('classification');
      })
      this.$Bus.$on('category', (data) => {

        this.openLoading()
        this.getData()
      })
    },
    beforeDestroy() {
      this.$Bus.$off('esParams')
      this.$Bus.$off('sublibrary')
      this.$Bus.$off('classification')
      this.$Bus.$off('category')
    },
    methods: {
      pagin(){
        this.$refs.pagin.currentPage = 1
      },
      openLoading(loadingDom){
        this.loading = Loading.service({
          lock: false,
          text: '请稍后',
          background: 'rgba(255, 255, 255, 0.7)',
          target: loadingDom || 'body'
        })
      },
      closeLoading () {
        return new Promise((resolve, reject) => {
          setTimeout(()=>{
            this.loading && this.loading.close()
            resolve(1)
          },200)
        })
      },
      handerChange(val) {
        this.tableData = []
        this.currPage = val
        this.getData()
      },
      getData() {
        let params = {
          typeId: this.$store.state.typeId,
          index1: 'ancientbook',
          esParams: [],
          page: this.currPage,
          limit: this.limit,
        }
        //默认审核和主书检索
        params.esParams.push(
          //     {
          //     searchName: "masterSlave",
          //     searchRelation: 1,
          //     searchType: 1,
          //     searchValue: "主",
          // },
          {
            searchName: "examineState",
            searchRelation: 1,
            searchType: 1,
            searchValue: "1",
          })
        if (sessionStorage.getItem('esParams')) {
          // params.esParams.push(...this.pageEsParams)
          const esParams = [...JSON.parse(sessionStorage.getItem('esParams'))]
          esParams.map(data => {
            delete data.guid
            return data
          })
          params.esParams.push(...esParams)
        }
        if (sessionStorage.getItem('sublibrary')) {
          params.esParams.push(JSON.parse(sessionStorage.getItem('sublibrary')))
        }
        if (sessionStorage.getItem('classification')) {
          params.esParams.push(...JSON.parse(sessionStorage.getItem('classification')))
        }
        if (sessionStorage.getItem('category')) {
          params.esParams.push(JSON.parse(sessionStorage.getItem('category')))
        }
        mainSearch(params).then(async res => {
          if (res.data.code == 200) {
            await this.closeLoading()
            this.dataList = JSON.parse(JSON.stringify(res.data.data.list))
            this.dataList.map((data) => {
              data.categoryName = this.$store.state.categoryData.find(e => e.id == data.category).name
              return data
            })
            this.num = res.data.data.count
            this.count = res.data.data.count

          }
        })
      }
    },
  };
</script>

<style lang="less" scoped>
  .r-main {
    .r-nums {
      width: 47.188rem;
      height: 2.083rem;
      line-height: 2.083rem;
      padding-left: 1.094rem;
      margin-bottom: 1.042rem;
      font-size: 0.833rem;
      color: #333333;
      background-color: #f8f1f1;

      span {
        color: #b73d43;
        font-size: 0.983rem;
      }
    }
  }
</style>
